// 首页接口
import { get, post } from '~/assets/js/api/methods'

import apiList from '~/env.config'
const { ipServer, fxServer, fxClient, shieldServer } = apiList

export const getMyCity = 'https://exportedbase.interface003.com/ip138/getcity' // 获取城市接口
export default axios => ({
  myIPApi: (params = {}) => get(axios, `${ipServer}/api/v1/getipgeo`, params), // 根据IP获取当前用户所在的国家
  dropdown: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/trader/dropdown-v1`, params), // 头部实时搜索
  contactInfo: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/wikifx/contactinfo/init-v1`, params), // 公用底部联系方式
  countryHot: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/country/hot-v1`, params), // 公用底部国家列表弹框
  countrySearch: (params = {}) => get(axios, `${fxClient}/wikifxweb-v1/country/search-v1`, params), // 公用底部搜索国家弹框
  showMenu: (params = {}) => get(axios, `${shieldServer}/api/shieldcenter/fx/get`, params), // 是否展示菜单栏中的某一项
  sentimentCurrencyServer: (headers = {}, params = {}) => post(axios, `${fxServer}/wikifxweb-v1/invoke-v3/dkqx`, params, headers), // 获取多空情绪模块某一个交易商的货币对——服务端
  sentimentCurrencyClient: (headers = {}, params = {}) => post(axios, `${fxClient}/wikifxweb-v1/invoke-v3/dkqx`, params, headers), // 获取多空情绪模块某一个交易商的货币对——客户端
  vpsInfo: (params = {}) => get(axios, `${fxServer}/wikifxweb-v1/vps/uhost-v1`, params), // VPS普通版专业版详情
  getmanybyproj: (headers = {}, params = {}) => get(axios, `${shieldServer}/api/shieldcenter/wikifx/getmanybyproj`, params, headers), // 红框是否展示
  riskcontrol: (headers = {}, params = {}) => get(axios, `${fxServer}/wikifxweb-v1/riskcontrol-v1`, params, headers) // 屏蔽点位
})
